import { differenceInDays, format } from "date-fns";
import moment from "moment";
import numeral from "numeral";
import Content from "../components/leasing.c.content";
import Button from "../components/leasing.c.button";
import { Fragment, memo, useContext, useEffect, useRef, useState } from "react";
import { ReversePaymentContext } from "components/Leasing/context/leasing.ctx.reversePayment";
import { getInterestReduction } from "components/Leasing/utils/leasing.u";
import { getDetailSegment } from "../utils/buro";
import axios from "axios";
import classNames from "classnames";
import { EmitterStatus } from "../../../event";
import { Dialog, Menu, Transition } from "@headlessui/react";
import Select from "react-select";
import { provinces } from "components/Leasing/constrant/leasing.ct.options";
import API from "../api/api.main";
import { Auth, Storage } from "aws-amplify";
import { getCurrentLocalDateTime } from "../../../utils/getLocalDateTime";
import ReactFlow, {
  MiniMap,
  Controls,
  Background,
  useStoreApi,
  useReactFlow,
  ReactFlowProvider,
  Handle,
} from "react-flow-renderer";
import "reactflow/dist/style.css";

const nodes = [
  {
    id: "1",
    position: { x: 600, y: 300 },
    data: { label: "1" },
    width: 100,
    height: 100,
    sourcePosition: "bottom",
    targetPosition: "bottom",
  },
  {
    id: "2",
    position: { x: 600, y: 600 },
    data: { label: "2" },
    width: 100,
    height: 100,
    targetPosition: "right",
    sourcePosition: "top",
  },
  {
    id: "3",
    position: { x: 900, y: 600 },
    data: { label: "3" },
    width: 100,
    height: 100,
    targetPosition: "right",
    sourcePosition: "left",
  },
  {
    id: "4",
    position: { x: 1200, y: 600 },
    data: { label: "4" },
    width: 100,
    height: 100,
    targetPosition: "right",
    sourcePosition: "left",
  },
  {
    id: "5",
    position: { x: 600, y: 900 },
    data: { label: "4" },
    width: 100,
    height: 100,
    targetPosition: "right",
    sourcePosition: "top",
  },
];

const edges = [
  { id: "e2-1", source: "2", target: "1" },
  {
    id: "e3-2",
    source: "3",
    target: "2",
  },
  {
    id: "e4-3",
    source: "4",
    target: "3",
  },
  {
    id: "e2-5",
    source: "5",
    target: "1",
  },
];

function CustomNode({ dateTime, label, paid_amount }) {
  return (
    <>
      <div className="flex flex-col justify-center">
        <div>{label}</div>
        {dateTime && <div>({dateTime})</div>}
        {paid_amount && <div>({paid_amount} บาท)</div>}
      </div>
    </>
  );
}

// we define the nodeTypes outside of the component to prevent re-renderings
// you could also use useMemo inside the component
const nodeTypes = { custom: CustomNode };

function FlowProvider(props) {
  return <ReactFlowProvider>{props?.children}</ReactFlowProvider>;
}

function Flow({ env = "sandboc", loan_id, ...props }) {
  const [firstRender, setFirstRender] = useState(true);
  const [loading, setLoading] = useState(true);
  const store = useStoreApi();
  // const [nodes, setNodes] = useState([]);
  // const [edges, setEdges] = useState([]);
  const { setCenter } = useReactFlow();

  const focusNode = () => {
    const { nodeInternals } = store.getState();
    const nodes = Array.from(nodeInternals).map(([, node]) => node);

    if (nodes.length > 0) {
      const node = nodes[0];

      const x = node.position.x + node.width / 2;
      const y = node.position.y + node.height / 2;
      const zoom = 0.7;

      setCenter(x, y, { zoom, duration: 600 });
    }
  };
  useEffect(() => {
    if (loading) return;
    if (firstRender) {
      setFirstRender(false);
      return;
    } else {
      focusNode();
    }
  }, [firstRender, loading]);

  useEffect(() => {
    if (loan_id) {
      // fetchData();
    }
  }, [loan_id]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const pathUrl =
        env === "prod" ? "/leasing/flow" : "/leasing/loanSandbox/flow";
      const { flow } = await API.get("MoneyHubAdmin", `${pathUrl}/${loan_id}`, {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });

      const flowKeys = Object.keys(flow?.data)
        .reduce((prev, currKey) => {
          if (flow.data[currKey]?.length > 0) {
            const filterInterfaceCreate = flow.data[currKey].filter(
              (action) => action.type === "interface_create"
            );
            console.log("filterInterfaceCreate", filterInterfaceCreate);
            if (filterInterfaceCreate.length > 0) {
              return [
                ...prev,
                ...new Array(flow.data[currKey].length).fill(currKey),
              ];
            }
          }
          return [...prev, currKey];
        }, [])
        .sort((aDate, bDate) => {
          return new Date(aDate) - new Date(bDate);
        });

      const sameNode = {
        width: 150,
        height: 100,
      };

      const firstInterfaceCreate = format(new Date(flowKeys[0]), "dd-MM-yyyy");
      const remainFlowKeys = flowKeys.slice(1);
      let defaultPosition = { x: 600, y: 300 };
      let nodes = [
        {
          ...sameNode,
          id: "1",
          position: defaultPosition,
          data: {
            label: (
              <CustomNode
                dateTime={firstInterfaceCreate}
                label={"interface_create"}
              />
            ),
          },
          targetPosition: "bottom",
          sourcePosition: "bottom",
        },
      ];
      let edges = [];

      let countNode = nodes.length + 1;
      let countActionNode = 0;
      for (let index = 0; index < remainFlowKeys.length; index++) {
        const remainFlowKey = remainFlowKeys[index];
        const oriNode = {
          ...sameNode,
          id: `${countNode}`,
          position: {
            x: defaultPosition.x,
            y: defaultPosition.y + 200 * (index + 1),
          },
          data: { label: `${format(new Date(remainFlowKey), "dd-MM-yyyy")}` },
          targetPosition: "top",
          sourcePosition: "right",
        };
        const edge = {
          id: `e${countNode - 1 - countActionNode}-${
            countNode - countActionNode
          }`,
          source: `${countNode - 1 - countActionNode}`,
          target: `${countNode - countActionNode}`,
        };
        edges.push(edge);
        nodes.push(oriNode);
        countNode++;
        let indexAction = 0;
        let actions = flow.data[remainFlowKey]
          .filter((action) => action?.type !== "interface_create")
          .sort((aDate, bDate) => {
            return new Date(aDate?.dateTime) - new Date(bDate?.dateTime);
          });
        for (const action of actions) {
          const dateTime = action?.dateTime
            ? format(new Date(action?.dateTime), "HH:mm")
            : null;
          const actionType = action.type;
          const node = {
            ...sameNode,
            id: `${countNode}`,
            position: {
              x: defaultPosition.x + 300 * (indexAction + 1),
              y: oriNode.position.y - 11,
            },
            data: {
              label: (
                <CustomNode
                  // dateTime={dateTime}
                  label={actionType}
                  paid_amount={action?.paid_amount}
                />
              ),
            },
            targetPosition: "left",
            sourcePosition: "right",
          };
          const edge = {
            id: `e${countNode - 1}-${countNode}`,
            source: `${countNode - 1}`,
            target: `${countNode}`,
          };
          edges.push(edge);
          nodes.push(node);
          countActionNode++;
          countNode++;
          indexAction++;
        }
      }
      setNodes(nodes);
      setEdges(edges);
    } catch (error) {
      console.log("fetch data error", error);
      alert(error);
    } finally {
      setLoading(false);
    }
  };

  // if (loading) return <div>Loading...</div>;

  return (
    <ReactFlow
      style={{ width: "100vw", height: "70vh", marginRight: "1.2rem" }}
      nodes={nodes}
      edges={edges}
      nodesDraggable={false}
      nodesConnectable={false}
      deleteKeyCode={null}
      // nodeTypes={nodeTypes}
      fitView
      // onNodesChange={onNodesChange}
      // onEdgesChange={onEdgesChange}
      // onConnect={onConnect}
    >
      <Background color="#aaa" gap={16} />

      {/* <MiniMap />
                  <Controls /> */}
    </ReactFlow>
  );
}

export const PLANT = [
  "0015",
  "M001",
  "M002",
  "M003",
  "M004",
  "M005",
  "M006",
  "M007",
  "M008",
  "M009",
  "M010",
].map((item) => {
  return {
    label: item,
    value: item,
  };
});

export const NEW_PLANT = [
  "0015",
  "N001",
  "N002",
  "N003",
  "N004",
  "N005",
  "N006",
  "N007",
  "N008",
  "N009",
  "N010",
].map((item) => {
  return {
    label: item,
    value: item,
  };
});

export const LOCATION = [
  "1501",
  "0101",
  "0201",
  "0301",
  "0401",
  "0501",
  "0601",
  "0701",
  "0801",
  "0901",
  "1001",
].map((item) => {
  return {
    label: item,
    value: item,
  };
});

function useComponentVisible(setOpen) {
  const ref = useRef(null);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return { ref };
}
const FootageLoanMetaData = ({
  env = "sandbox",
  date,
  loan,
  setOpenModal,
  setOpenModalBuro,
  setOpenModalInterfaceCreate,
  setOpenModalARClear,
  setOpenModalAccruedInterest,
  setOpenModalPost,
  setOpenModalContractCancel,
  setOpenModalSeizeVehicle,
  setOpenModalTransferVehicle,
  setBuroData,
  paidDate,
  getLoanId,
}) => {
  const { setOpenReverse } = useContext(ReversePaymentContext);
  const [loadingTrigger, setLoadingTrigger] = useState(false);
  const [loadingCancel, setLoadingCancel] = useState(false);
  const [loadingXml, setLoadingXml] = useState(false);
  const [loadingTransfer, setLoadingTransfer] = useState(false);

  const [menuInfo, setMenuInfo] = useState(false);
  const [menuTrigger, setMenuTrigger] = useState(false);
  const [menuSend, setMenuSend] = useState(false);
  const [menuXml, setMenuXml] = useState(false);

  const [openFlow, setOpenFlow] = useState(false);

  const [openCancel, setOpenCancel] = useState(false);
  const [formCancel, setFormCancel] = useState({});
  const [openTransfer, setOpenTransfer] = useState(false);
  const [formTransfer, setFormTransfer] = useState({});

  const { ref: menuInfoRef } = useComponentVisible(setMenuInfo);
  const { ref: menuTriggerRef } = useComponentVisible(setMenuTrigger);
  const { ref: menuSendRef } = useComponentVisible(setMenuSend);
  const { ref: menuXmlRef } = useComponentVisible(setMenuXml);

  useEffect(() => {
    setMenuTrigger(false);
    setMenuSend(false);
  }, [menuInfo]);

  useEffect(() => {
    setMenuInfo(false);
    setMenuSend(false);
  }, [menuTrigger]);

  useEffect(() => {
    setMenuInfo(false);
    setMenuTrigger(false);
  }, [menuSend]);

  useEffect(() => {
    if (loan?.category === "TF") {
      let OUTSTANDING_AR = Number(
        Number(
          loan?.cancel_total_principle +
            loan?.cancel_total_principle_vat +
            loan?.cancel_total_interest +
            loan?.cancel_total_interest_vat
        ).toFixed(2)
      );
      let OUTSTANDING_INTEREST = Number(
        Number(loan?.cancel_total_interest_sap).toFixed(2)
      );
      let OUTSTANDING_TAX = Number(
        Number(
          loan?.cancel_total_interest_vat_sap +
            loan?.cancel_total_principle_vat_sap
        ).toFixed(2)
      );
      let ASSET_FOR_SALES = Number(
        Number(OUTSTANDING_AR - OUTSTANDING_INTEREST - OUTSTANDING_TAX).toFixed(
          2
        )
      );

      setFormCancel({
        ...loan,
        ASSET_FOR_SALES,
        OUTSTANDING_AR,
        OUTSTANDING_INTEREST,
        OUTSTANDING_TAX,
        plant: PLANT[0],
        location: LOCATION[0],
        plate_province: !loan?.plate_province
          ? { label: provinces[0], value: provinces[0] }
          : "",
        gear: !loan?.gear
          ? { label: "AUTOMATIC", value: "AUTOMATIC" }
          : { label: loan?.gear, value: loan?.gear },
      });
      setFormTransfer({
        ...loan,
        source_plant: PLANT[0],
        source_location: LOCATION[0],
        dest_plant: PLANT[0],
        dest_location: LOCATION[0],
      });
    } else {
      let OUTSTANDING_AR = Number(Number(loan?.capitalRemain).toFixed(2));
      let OUTSTANDING_INTEREST = 0;
      let OUTSTANDING_TAX = Number(Number(0).toFixed(2));
      let ASSET_FOR_SALES = Number(Number(OUTSTANDING_AR).toFixed(2));
      setFormCancel({
        ...loan,
        cancel_total_period: loan?.period,
        ASSET_FOR_SALES,
        OUTSTANDING_AR,
        OUTSTANDING_INTEREST,
        OUTSTANDING_TAX,
        plant: PLANT[0],
        location: LOCATION[0],
        plate_province: !loan?.plate_province
          ? { label: provinces[0], value: provinces[0] }
          : "",
        gear: !loan?.gear
          ? { label: "AUTOMATIC", value: "AUTOMATIC" }
          : { label: loan?.gear, value: loan?.gear },
      });
      setFormTransfer({
        ...loan,
        source_plant: PLANT[0],
        source_location: LOCATION[0],
        dest_plant: PLANT[0],
        dest_location: LOCATION[0],
      });
    }
  }, [loan]);

  const onClickOpenModalBuro = () => {
    setOpenModalBuro(true);

    const newBuroData = getDetailSegment({
      currentDate: paidDate,
      dataExport: [{ ...loan, paid_date_latest: loan?.paidDateLatest }],
      showLog: true,
      showConsole: true,
    });
    setBuroData(newBuroData);
  };

  const onClickTriggerAccrued = async () => {
    try {
      setLoadingTrigger(true);

      const { data } = await axios.post(
        "https://j3glljytyvmcsgpo2cugffk3by0vivjw.lambda-url.ap-southeast-1.on.aws",
        {
          env: "trigger_accrued",
          period: "single",
          Limit: 100,
          trigger_date: paidDate,
          REFERENCE: loan?.loan_id,
          isPro: env !== "sandbox",
        }
      );

      const pathUrl =
        env === "prod"
          ? "/leasing/triggerAccrued"
          : "/leasing/loanSandbox/triggerAccrued";

      // const { data } = await API.post("MoneyHubAdmin", `${pathUrl}`, {
      //   body: {
      //     // env: "trigger_accrued",
      //     // period: "all",
      //     // Limit: 100,
      //     // trigger_date: paidDate,
      //     env: "trigger_accrued",
      //     period: "single",
      //     Limit: 100,
      //     trigger_date: paidDate,
      //     REFERENCE: loan?.loan_id,
      //     isPro: env !== "sandbox",
      //   },
      //   headers: {
      //     Authorization: `Bearer ${(await Auth.currentSession())
      //       .getIdToken()
      //       .getJwtToken()}`,
      //   },
      // });
      await EmitterStatus("SUCCESS", {
        text: data?.timeDuration ? `Time: ${data?.timeDuration}` : "Success",
      });
      console.log("data", data);
    } catch (error) {
      console.log("error", error);
      await EmitterStatus("ERROR", {
        text: `${error?.response?.data?.message}`,
      });
    } finally {
      setLoadingTrigger(false);
    }
  };

  const onClickTriggerCancel = async () => {
    try {
      setLoadingTrigger(true);
      const { data } = await axios.post(
        "https://j3glljytyvmcsgpo2cugffk3by0vivjw.lambda-url.ap-southeast-1.on.aws",
        {
          env: "trigger_break_fee",
          period: "single",
          Limit: 100,
          trigger_date: paidDate,
          isPro: env !== "sandbox",
          REFERENCE: loan?.loan_id,
        }
      );
      await EmitterStatus("SUCCESS", {
        text: data?.timeDuration ? `Time: ${data?.timeDuration}` : "Success",
      });
      console.log("data", data);
    } catch (error) {
      console.log("error", error);
      await EmitterStatus("ERROR", {
        text: `${error?.response?.data?.message}`,
      });
    } finally {
      setLoadingTrigger(false);
    }
  };

  const onClickSendInterfaceCreate = async () => {
    try {
      setLoadingTrigger(true);
      const { data } = await axios.post(
        "https://yqt7xj4v3tylrse5i5ly2q6rru0uqogj.lambda-url.ap-southeast-1.on.aws",
        {
          env: "single",
          trigger_date: paidDate,
          REFERENCE: loan?.loan_id,
          isPro: env !== "sandbox",
        }
      );
      await EmitterStatus(
        data?.pushItems[0]?.MESSAGE_TYPE === "E" ? "ERROR" : "SUCCESS",
        {
          text: `Time: ${data?.timeDuration}, MESSAGE: ${data?.pushItems[0]?.MESSAGE}, MESSAGE_TYPE: ${data?.pushItems[0]?.MESSAGE_TYPE}`,
        }
      );
      console.log("data", data);
    } catch (error) {
      console.log("error", error);
      await EmitterStatus("ERROR", {
        text: `${error?.response?.data?.message || ""}`,
      });
    } finally {
      setLoadingTrigger(false);
    }
  };

  const onClickSendAccruedInterest = async () => {
    try {
      setLoadingTrigger(true);
      const { data } = await axios.post(
        "https://7vgfsog43keksqfhhf7w2dz7cu0dpfca.lambda-url.ap-southeast-1.on.aws",
        {
          env: "single",
          trigger_date: paidDate,
          REFERENCE: loan?.loan_id,
          isPro: env !== "sandbox",
        }
      );
      await EmitterStatus(
        data?.pushItems[0]?.MESSAGE_TYPE === "E" ? "ERROR" : "SUCCESS",
        {
          text: `Time: ${data?.timeDuration}, MESSAGE: ${
            data?.pushItems[0]?.MESSAGE || ""
          }, MESSAGE_TYPE: ${data?.pushItems[0]?.MESSAGE_TYPE || ""}`,
        }
      );
      console.log("data", data);
    } catch (error) {
      console.log("error", error?.response);
      await EmitterStatus("ERROR", {
        text: `${error?.response?.data?.message || ""}`,
      });
    } finally {
      setLoadingTrigger(false);
    }
  };

  const onClickSendARClear = async () => {
    try {
      setLoadingTrigger(true);
      const { data } = await axios.post(
        "https://fhy6gbuvwafcyzp2t66qeg5vjq0jpiiz.lambda-url.ap-southeast-1.on.aws",
        {
          env: "single",
          trigger_date: paidDate,
          REFERENCE: loan?.loan_id,
          isPro: env !== "sandbox",
        }
      );
      await EmitterStatus(
        data?.pushItems[0]?.MESSAGE_TYPE === "E" ? "ERROR" : "SUCCESS",
        {
          text: `Time: ${data?.timeDuration}, MESSAGE: ${
            data?.pushItems[0]?.MESSAGE || ""
          }, MESSAGE_TYPE: ${data?.pushItems[0]?.MESSAGE_TYPE || ""}`,
        }
      );
      console.log("data", data);
    } catch (error) {
      console.log("error", error);
      await EmitterStatus("ERROR", {
        text: `${error?.response?.data?.message || ""}`,
      });
    } finally {
      setLoadingTrigger(false);
    }
  };

  const onClickSendCancel = async () => {
    try {
      setLoadingTrigger(true);
      const { data } = await axios.post(
        "https://ksw43mvwz2qrjdsacamhb42fwe0vihfp.lambda-url.ap-southeast-1.on.aws",
        {
          env: "single",
          trigger_date: paidDate,
          REFERENCE: loan?.loan_id,
          isPro: env !== "sandbox",
        }
      );
      await EmitterStatus(
        data?.pushItems[0]?.MESSAGE_TYPE === "E" ? "ERROR" : "SUCCESS",
        {
          text: `Time: ${data?.timeDuration}, MESSAGE: ${
            data?.pushItems[0]?.MESSAGE || ""
          }, MESSAGE_TYPE: ${data?.pushItems[0]?.MESSAGE_TYPE || ""}`,
        }
      );
      console.log("data", data);
    } catch (error) {
      console.log("error", error);
      await EmitterStatus("ERROR", {
        text: `${error?.response?.data?.message || ""}`,
      });
    } finally {
      setLoadingTrigger(false);
    }
  };

  const onClickSendSeizeVehicle = async () => {
    try {
      setLoadingTrigger(true);
      const { data } = await axios.post(
        "https://564rkckseszprdkoknybxhdb440hbzej.lambda-url.ap-southeast-1.on.aws",
        {
          env: "single",
          trigger_date: paidDate,
          REFERENCE: loan?.loan_id,
          isPro: env !== "sandbox",
        }
      );
      await EmitterStatus(
        data?.pushItems[0]?.MESSAGE_TYPE === "E" ? "ERROR" : "SUCCESS",
        {
          text: `Time: ${data?.timeDuration}, MESSAGE: ${
            data?.pushItems[0]?.MESSAGE || ""
          }, MESSAGE_TYPE: ${data?.pushItems[0]?.MESSAGE_TYPE || ""}`,
        }
      );
      console.log("data", data);
    } catch (error) {
      console.log("error", error);
      await EmitterStatus("ERROR", {
        text: `${error?.response?.data?.message || ""}`,
      });
    } finally {
      setLoadingTrigger(false);
    }
  };

  const onClickSendTransferVehicle = async () => {
    try {
      setLoadingTrigger(true);
      const { data } = await axios.post(
        "https://efno5vynproeit3ricsj6m5cte0nyery.lambda-url.ap-southeast-1.on.aws",
        {
          env: "single",
          trigger_date: paidDate,
          REFERENCE: loan?.loan_id,
          isPro: env !== "sandbox",
        }
      );
      await EmitterStatus(
        data?.pushItems[0]?.MESSAGE_TYPE === "E" ? "ERROR" : "SUCCESS",
        {
          text: `Time: ${data?.timeDuration}, MESSAGE: ${
            data?.pushItems[0]?.MESSAGE || ""
          }, MESSAGE_TYPE: ${data?.pushItems[0]?.MESSAGE_TYPE || ""}`,
        }
      );
      console.log("data", data);
    } catch (error) {
      console.log("error", error);
      await EmitterStatus("ERROR", {
        text: `${error?.response?.data?.message || ""}`,
      });
    } finally {
      setLoadingTrigger(false);
    }
  };

  const onClickSendPostOtherRevenue = async () => {
    try {
      setLoadingTrigger(true);
      const { data } = await axios.post(
        "https://ofrq4lxwgq56szwyfipksl5ntu0edqmd.lambda-url.ap-southeast-1.on.aws",
        {
          env: "single",
          trigger_date: paidDate,
          REFERENCE: loan?.loan_id,
          isPro: env !== "sandbox",
        }
      );
      await EmitterStatus(
        data?.pushItems[0]?.MESSAGE_TYPE === "E" ? "ERROR" : "SUCCESS",
        {
          text: `Time: ${data?.timeDuration}, MESSAGE: ${
            data?.pushItems[0]?.MESSAGE || ""
          }, MESSAGE_TYPE: ${data?.pushItems[0]?.MESSAGE_TYPE || ""}`,
        }
      );
      console.log("data", data);
    } catch (error) {
      console.log("error", error);
      await EmitterStatus("ERROR", {
        text: `${error?.response?.data?.message || ""}`,
      });
    } finally {
      setLoadingTrigger(false);
    }
  };

  const onClickTriggerDemandFee = async () => {
    try {
      setLoadingTrigger(true);

      // const pathUrl =
      //   env === "prod"
      //     ? "/leasing/triggerDemandFee"
      //     : "/leasing/loanSandbox/triggerDemandFee";
      // const { data } = await API.post("MoneyHubAdmin", `${pathUrl}`, {
      //   body: {
      //     env: "trigger_demand_fee",
      //     period: "all",
      //     Limit: 100,
      //     trigger_date: paidDate,
      //   },
      //   headers: {
      //     Authorization: `Bearer ${(await Auth.currentSession())
      //       .getIdToken()
      //       .getJwtToken()}`,
      //   },
      // });
      const { data } = await axios.post(
        "https://j3glljytyvmcsgpo2cugffk3by0vivjw.lambda-url.ap-southeast-1.on.aws",
        {
          env: "trigger_demand_fee",
          period: "single",
          Limit: 100,
          trigger_date: paidDate,
          isPro: env !== "sandbox",
          REFERENCE: loan?.loan_id,
        }
      );
      await EmitterStatus("SUCCESS", {
        text: data?.timeDuration ? `Time: ${data?.timeDuration}` : "Success",
      });
      console.log("data", data);
    } catch (error) {
      console.log("error", error);
      await EmitterStatus("ERROR", {
        text: `${error?.response?.data?.message}`,
      });
    } finally {
      setLoadingTrigger(false);
    }
  };

  const onChangeFormCancel = (e) => {
    const { name, value } = e.target;
    setFormCancel({ ...formCancel, [name]: value });
  };

  const onClickSubmitCancel = async () => {
    try {
      setLoadingCancel(true);

      const pathUrl =
        env === "prod"
          ? "/leasing/seizeVehicle"
          : "/leasing/loanSandbox/seizeVehicle";
      await API.post("MoneyHubAdmin", `${pathUrl}`, {
        body: {
          ...formCancel,
          paid_date: date,
          plate_province: formCancel?.plate_province.value,
          gear: formCancel?.gear.value,
          plant: formCancel?.plant?.value,
          location: formCancel?.location?.value,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      localStorage.setItem(
        `${loan?.loan_id}_date`,
        getCurrentLocalDateTime(paidDate).fullDate
      );
      await EmitterStatus("SUCCESS");
      setOpenCancel(false);
      await getLoanId(true, date);
    } catch (error) {
    } finally {
      setLoadingCancel(false);
    }
  };

  const onClickSubmitTransfer = async () => {
    try {
      setLoadingTransfer(true);

      const pathUrl =
        env === "prod"
          ? "/leasing/transferVehicle"
          : "/leasing/loanSandbox/transferVehicle";
      await API.post("MoneyHubAdmin", `${pathUrl}`, {
        body: {
          ...formTransfer,
          source_plant: formTransfer?.source_plant.value,
          source_location: formTransfer?.source_location.value,
          dest_plant: formTransfer?.dest_plant.value,
          dest_location: formTransfer?.dest_location.value,
          paid_date: date,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      await EmitterStatus("SUCCESS");
      setOpenTransfer(false);
      await getLoanId(true, date);
    } catch (error) {
    } finally {
      setLoadingTransfer(false);
    }
  };

  function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    const clickHandler = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener("click", clickHandler);
      }, 150);
    };
    a.addEventListener("click", clickHandler, false);
    a.click();
    return a;
  }

  const onClickXml = async (eventType) => {
    try {
      setLoadingXml(true);
      await new Promise((resolve) => {
        setTimeout(async () => {
          try {
            const fileName = `${loan?.loan_id}_${eventType}.xml`;
            const result = await Storage.get(fileName, { download: true });
            downloadBlob(result.Body, fileName);
            resolve(true);
          } catch (error) {
            resolve(true);
          }
        }, 1000);
      });
    } catch (error) {
    } finally {
      setLoadingXml(false);
    }
  };

  const onClickOpenReverse = () => {
    if (!["ACTIVE", "DONE"].includes(loan.loan_status)) return;
    setOpenReverse(true);
  };

  return (
    <div className="bg-white px-1 py-2">
      <div className="flex flex-row justify-between p-2 mb-3">
        <div className="font-bold text-lg text-coolGray-700">
          ข้อมูลสินเชื่อ ({loan?.category === "TF" && "เช่าซื้อ"}
          {loan?.category === "NTF" && "จำนำ"}, {loan?.loan_status})
        </div>
        <div className="flex space-x-2 text-sm">
          <Button
            onClick={onClickOpenReverse}
            className={classNames("bg-orange-600 rounded-full", {
              "bg-gray-400 cursor-not-allowed": !["ACTIVE", "DONE"].includes(
                loan?.loan_status
              ),
              "bg-orange-600": ["ACTIVE", "DONE"].includes(loan?.loan_status),
            })}
          >
            ระบบย้อนเวลาการชำระเงิน
          </Button>
          {/* <Button
            onClick={() => onClickOpenModalBuro(true)}
            className="bg-green-500 rounded-full"
          >
            ข้อมูลบูโร
          </Button> */}

          {/* <Button
            onClick={() => {
              setOpenFlow(true);
            }}
            className={classNames(" rounded-full  ", {
              // "bg-gray-500 cursor-not-allowed": loan?.category === "NTF",
              "bg-sky-500": true,
            })}
          >
            Flow
          </Button> */}

          <Button
            onClick={() => {
              setOpenTransfer(true);
            }}
            className={classNames(" rounded-full  ", {
              // "bg-gray-500 cursor-not-allowed": loan?.category === "NTF",
              "bg-fuchsia-500": true,
            })}
          >
            โอนย้าย
          </Button>

          <Button
            onClick={() => {
              if (loan.loan_status === "SEIZE") return;
              setOpenCancel(true);
            }}
            className={classNames(" rounded-full ", {
              // "bg-gray-500 cursor-not-allowed": loan?.category === "NTF",
              "bg-red-500": loan?.loan_status !== "SEIZE",
              "bg-gray-400 cursor-not-allowed": loan?.loan_status === "SEIZE",
            })}
          >
            ยึดรถ
          </Button>

          <Transition
            show={openFlow}
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Dialog
              as="div"
              className="fixed inset-0 z-10 overflow-y-auto"
              onClose={() => setOpenFlow(false)}
            >
              <div className="min-h-screen px-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-50"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-50"
                  leaveTo="opacity-0"
                >
                  <Dialog.Overlay className="fixed inset-0 bg-black opacity-50" />
                </Transition.Child>
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <div className="border border-gray-200 z-50 inline-block w-full h-full p-6 my-8 overflow-visible text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900 flex justify-between"
                    >
                      <FlowProvider>
                        <Flow loan_id={loan?.loan_id} />
                      </FlowProvider>
                    </Dialog.Title>
                  </div>
                </Transition.Child>
              </div>
            </Dialog>
          </Transition>

          <Transition
            show={openCancel}
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Dialog
              as="div"
              className="fixed inset-0 z-10 overflow-y-auto"
              onClose={() => setOpenCancel(false)}
            >
              <div className="min-h-screen px-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-50"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-50"
                  leaveTo="opacity-0"
                >
                  <Dialog.Overlay className="fixed inset-0 bg-black opacity-50" />
                </Transition.Child>
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <div className="border border-gray-200 z-50 inline-block w-2/3 p-6 my-8 overflow-visible text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900 flex justify-between"
                    >
                      <div>
                        ยึดรถ (วันที่ยกเลิกสัญญา{" "}
                        {["", "-"].includes(loan?.breakFeeDate) || !loan
                          ? "-"
                          : format(new Date(loan?.breakFeeDate), "dd-MM-yyyy")}
                        )
                      </div>
                    </Dialog.Title>
                    <div className="grid grid-cols-3 gap-2">
                      <div className="mt-4">
                        <div>PLANT</div>
                        <Select
                          options={PLANT}
                          className="w-full"
                          name="plant"
                          onChange={(e) => {
                            setFormCancel({
                              ...formCancel,
                              plant: e,
                            });
                          }}
                          value={formCancel?.plant}
                        />
                      </div>
                      <div className="mt-4">
                        <div>LOCATION</div>
                        <Select
                          options={LOCATION}
                          className="w-full"
                          name="location"
                          onChange={(e) => {
                            setFormCancel({
                              ...formCancel,
                              location: e,
                            });
                          }}
                          value={formCancel?.location}
                        />
                      </div>

                      <div className="mt-4">
                        <div>สีรถ</div>
                        <input
                          type="text"
                          className="px-2 py-1 mr-auto bg-transparent  relative border border-blue-400 text-sm outline-none bg-gray-50 focus:outline-none focus:border-blue-500 focus:ring-0 ring-0 rounded w-full"
                          value={formCancel?.color}
                          name="color"
                          onChange={onChangeFormCancel}
                        />
                      </div>
                      <div className="mt-4">
                        <div>ทะเบียนรถ</div>
                        <input
                          type="text"
                          className="px-2 py-1 mr-auto bg-transparent  relative border border-blue-400 text-sm outline-none bg-gray-50 focus:outline-none focus:border-blue-500 focus:ring-0 ring-0 rounded w-full"
                          value={formCancel?.plate}
                          name="plate"
                          onChange={onChangeFormCancel}
                        />
                      </div>
                      <div className="mt-4">
                        <div>จังหวัดทะเบียนรถ</div>
                        <Select
                          options={provinces?.map((province) => {
                            return {
                              label: province,
                              value: province,
                            };
                          })}
                          className="w-full"
                          name="plate_province"
                          onChange={(e) => {
                            setFormCancel({
                              ...formCancel,
                              plate_province: e,
                            });
                          }}
                          value={formCancel?.plate_province}
                        />
                      </div>
                      <div className="mt-4">
                        <div>หมายเลขตัวถังรถ</div>
                        <input
                          type="text"
                          className="px-2 py-1 mr-auto bg-transparent relative border border-blue-400 text-sm outline-none bg-gray-50 focus:outline-none focus:border-blue-500 focus:ring-0 ring-0 rounded w-full"
                          value={formCancel?.tankNumber}
                          name="tankNumber"
                          onChange={onChangeFormCancel}
                        />
                      </div>
                      <div className="mt-4">
                        <div>ยี่ห้อรถ</div>
                        <input
                          type="text"
                          className="px-2 py-1 mr-auto bg-transparent relative border border-blue-400 text-sm outline-none bg-gray-50 focus:outline-none focus:border-blue-500 focus:ring-0 ring-0 rounded w-full"
                          value={formCancel?.brand}
                          name="brand"
                          onChange={onChangeFormCancel}
                        />
                      </div>
                      <div className="mt-4">
                        <div>รุ่น</div>
                        <input
                          type="text"
                          className="px-2 py-1 mr-auto bg-transparent relative border border-blue-400 text-sm outline-none bg-gray-50 focus:outline-none focus:border-blue-500 focus:ring-0 ring-0 rounded w-full"
                          value={formCancel?.model}
                          name="model"
                          onChange={onChangeFormCancel}
                        />
                      </div>
                      <div className="mt-4">
                        <div>รุ่นย่อย</div>
                        <input
                          type="text"
                          className="px-2 py-1 mr-auto bg-transparent relative border border-blue-400 text-sm outline-none bg-gray-50 focus:outline-none focus:border-blue-500 focus:ring-0 ring-0 rounded w-full"
                          value={formCancel?.subModel}
                          name="subModel"
                          onChange={onChangeFormCancel}
                        />
                      </div>
                      <div className="mt-4">
                        <div>ปีที่ผลิต</div>
                        <input
                          type="text"
                          className="px-2 py-1 mr-auto bg-transparent relative border border-blue-400 text-sm outline-none bg-gray-50 focus:outline-none focus:border-blue-500 focus:ring-0 ring-0 rounded w-full"
                          value={formCancel?.year}
                          name="year"
                          onChange={onChangeFormCancel}
                        />
                      </div>
                      <div className="mt-4">
                        <div>ประเภทเกียร์</div>
                        <Select
                          options={[
                            {
                              label: "AUTOMATIC",
                              value: "AUTOMATIC",
                            },
                            {
                              label: "MANUAL",
                              value: "MANUAL",
                            },
                          ]}
                          className="w-full"
                          name="gear"
                          onChange={(e) => {
                            setFormCancel({
                              ...formCancel,
                              gear: e,
                            });
                          }}
                          value={formCancel?.gear}
                        />
                      </div>
                      <div className="mt-4">
                        <div>ราคากลาง ณ วันทำสัญญา</div>
                        <input
                          type="number"
                          className="px-2 py-1 mr-auto bg-transparent relative border border-blue-400 text-sm outline-none bg-gray-50 focus:outline-none focus:border-blue-500 focus:ring-0 ring-0 rounded w-full"
                          value={formCancel?.value}
                          name="value"
                          onChange={onChangeFormCancel}
                        />
                      </div>
                      <div className="mt-4">
                        <div>ราคาประเมิน ณ วันที่ยึดรถ</div>
                        <input
                          type="number"
                          className="px-2 py-1 mr-auto bg-transparent relative border border-blue-400 text-sm outline-none bg-gray-50 focus:outline-none focus:border-blue-500 focus:ring-0 ring-0 rounded w-full"
                          value={formCancel?.cur_mean_price}
                          name="cur_mean_price"
                          onChange={onChangeFormCancel}
                        />
                      </div>
                      <div className="mt-4">
                        <div>หมายเลขเครื่อง</div>
                        <input
                          type="text"
                          className="px-2 py-1 mr-auto bg-transparent relative border border-blue-400 text-sm outline-none bg-gray-50 focus:outline-none focus:border-blue-500 focus:ring-0 ring-0 rounded w-full"
                          value={formCancel?.serialNumber}
                          name="serialNumber"
                          onChange={onChangeFormCancel}
                        />
                      </div>
                      <div className="mt-4">
                        <div>ปีที่จดทะเบียน</div>
                        <input
                          type="date"
                          className="px-2 py-1 mr-auto bg-transparent relative border border-blue-400 text-sm outline-none bg-gray-50 focus:outline-none focus:border-blue-500 focus:ring-0 ring-0 rounded w-full"
                          value={formCancel?.issueDate}
                          name="issueDate"
                          onChange={onChangeFormCancel}
                        />
                      </div>
                      <div className="mt-4">
                        <div>ระยะทางที่ใช้ หน่วยเป็น กิโลเมตร</div>
                        <input
                          type="text"
                          className="px-2 py-1 mr-auto bg-transparent relative border border-blue-400 text-sm outline-none bg-gray-50 focus:outline-none focus:border-blue-500 focus:ring-0 ring-0 rounded w-full"
                          value={formCancel?.distance}
                          name="distance"
                          onChange={onChangeFormCancel}
                        />
                      </div>
                      <div className="mt-4">
                        <div>วันที่ทะเบียนหมดอายุ</div>
                        <input
                          type="date"
                          className="px-2 py-1 mr-auto bg-transparent relative border border-blue-400 text-sm outline-none bg-gray-50 focus:outline-none focus:border-blue-500 focus:ring-0 ring-0 rounded w-full"
                          value={formCancel?.registerExpireDate}
                          name="registerExpireDate"
                          onChange={onChangeFormCancel}
                        />
                      </div>
                      <div className="mt-4">
                        <div>วันที่ประกันรถหมดอายุ</div>
                        <input
                          type="date"
                          className="px-2 py-1 mr-auto bg-transparent relative border border-blue-400 text-sm outline-none bg-gray-50 focus:outline-none focus:border-blue-500 focus:ring-0 ring-0 rounded w-full"
                          value={formCancel?.insuranceExpireDate}
                          name="insuranceExpireDate"
                          onChange={onChangeFormCancel}
                        />
                      </div>
                      <div className="mt-4">
                        <div>จำนวนงวดที่ค้าง</div>
                        <input
                          type="text"
                          className="px-2 py-1 mr-auto bg-transparent relative border border-blue-400 text-sm outline-none bg-gray-50 focus:outline-none focus:border-blue-500 focus:ring-0 ring-0 rounded w-full"
                          value={formCancel?.cancel_total_period}
                          name="cancel_total_period"
                          onChange={onChangeFormCancel}
                        />
                      </div>
                      <div className="mt-4">
                        <div>มูลค่าสินทรัพย์รอการขาย</div>
                        <input
                          type="text"
                          className="px-2 py-1 mr-auto bg-transparent relative border border-blue-400 text-sm outline-none bg-gray-50 focus:outline-none focus:border-blue-500 focus:ring-0 ring-0 rounded w-full"
                          value={formCancel?.ASSET_FOR_SALES}
                          name="ASSET_FOR_SALES"
                          onChange={onChangeFormCancel}
                        />
                      </div>
                      <div className="mt-4">
                        <div>ยอดหนี้คงค้าง</div>
                        <input
                          type="text"
                          className="px-2 py-1 mr-auto bg-transparent relative border border-blue-400 text-sm outline-none bg-gray-50 focus:outline-none focus:border-blue-500 focus:ring-0 ring-0 rounded w-full"
                          value={formCancel?.OUTSTANDING_AR}
                          name="OUTSTANDING_AR"
                          onChange={onChangeFormCancel}
                        />
                      </div>
                      <div className="mt-4">
                        <div>จำนวนเงินรายได้ดอกเบี้ย</div>
                        <input
                          type="text"
                          className="px-2 py-1 mr-auto bg-transparent relative border border-blue-400 text-sm outline-none bg-gray-50 focus:outline-none focus:border-blue-500 focus:ring-0 ring-0 rounded w-full"
                          value={formCancel?.OUTSTANDING_INTEREST}
                          name="OUTSTANDING_INTEREST"
                          onChange={onChangeFormCancel}
                        />
                      </div>
                      <div className="mt-4">
                        <div>จำนวนเงินภาษีมูลค่าเพิ่ม</div>
                        <input
                          type="text"
                          className="px-2 py-1 mr-auto bg-transparent relative border border-blue-400 text-sm outline-none bg-gray-50 focus:outline-none focus:border-blue-500 focus:ring-0 ring-0 rounded w-full"
                          value={formCancel?.OUTSTANDING_TAX}
                          name="OUTSTANDING_TAX"
                          onChange={onChangeFormCancel}
                        />
                      </div>
                    </div>
                    <div className="flex mt-6 space-x-3">
                      <Button
                        disabled={loadingCancel}
                        onClick={onClickSubmitCancel}
                        className={classNames("rounded", {
                          "bg-blue-500": !loadingCancel,
                          "bg-gray-500 cursor-not-allowed": loadingCancel,
                        })}
                      >
                        {loadingCancel ? "กำลังบันทึก..." : "ยืนยัน"}
                      </Button>
                      <Button
                        disabled={loadingCancel}
                        className={classNames("rounded", {
                          "bg-red-500": !loadingCancel,
                          "bg-gray-500 cursor-not-allowed": loadingCancel,
                        })}
                        onClick={() => setOpenCancel(false)}
                      >
                        ปิด
                      </Button>
                    </div>
                  </div>
                </Transition.Child>
              </div>
            </Dialog>
          </Transition>

          {/* Transfer */}
          <Transition
            show={openTransfer}
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Dialog
              as="div"
              className="fixed inset-0 z-10 overflow-y-auto"
              onClose={() => setOpenTransfer(false)}
            >
              <div className="min-h-screen px-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-50"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-50"
                  leaveTo="opacity-0"
                >
                  <Dialog.Overlay className="fixed inset-0 bg-black opacity-50" />
                </Transition.Child>
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <div className="border border-gray-200 z-50 inline-block w-3/4 p-6 my-8 overflow-visible text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900 flex justify-between"
                    >
                      <div>โอนย้าย</div>
                    </Dialog.Title>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="mt-4">
                        <div>
                          SOURCE_PLANT (ศูนย์ MHS ต้นทาง
                          ตามภูมิภาคที่จัดเก็บรถที่ยึดมา)
                        </div>
                        <Select
                          options={PLANT}
                          className="w-full"
                          name="source_plant"
                          onChange={(e) => {
                            setFormTransfer({
                              ...formTransfer,
                              source_plant: e,
                            });
                          }}
                          value={formTransfer?.source_plant}
                        />
                      </div>
                      <div className="mt-4">
                        <div>
                          SOURCE_LOCATION (สถานที่จัดเก็บรถภายใต้ ศูนย์ MHS
                          ต้นทาง ตามภูมิภาคที่จัดเก็บรถที่ยึดมา)
                        </div>
                        <Select
                          options={LOCATION}
                          className="w-full"
                          name="source_location"
                          onChange={(e) => {
                            setFormTransfer({
                              ...formTransfer,
                              source_location: e,
                            });
                          }}
                          value={formTransfer?.source_location}
                        />
                      </div>
                      <div className="mt-4">
                        <div>
                          DEST_PLANT (ศูนย์ MHS ปลายทาง
                          ตามภูมิภาคที่จัดเก็บรถที่ยึดมา)
                        </div>
                        <Select
                          options={NEW_PLANT}
                          className="w-full"
                          name="dest_plant"
                          onChange={(e) => {
                            setFormTransfer({
                              ...formTransfer,
                              dest_plant: e,
                            });
                          }}
                          value={formTransfer?.dest_plant}
                        />
                      </div>
                      <div className="mt-4">
                        <div>
                          DEST_LOCATION (สถานที่จัดเก็บรถภายใต้ ศูนย์ MHS
                          ปลายทาง ตามภูมิภาคที่จัดเก็บรถที่ยึดมา)
                        </div>
                        <Select
                          options={LOCATION}
                          className="w-full"
                          name="dest_location"
                          onChange={(e) => {
                            setFormTransfer({
                              ...formTransfer,
                              dest_location: e,
                            });
                          }}
                          value={formTransfer?.dest_location}
                        />
                      </div>
                    </div>
                    <div className="flex mt-6 space-x-3">
                      <Button
                        disabled={loadingTransfer}
                        onClick={onClickSubmitTransfer}
                        className={classNames("rounded", {
                          "bg-blue-500": !loadingTransfer,
                          "bg-gray-500 cursor-not-allowed": loadingTransfer,
                        })}
                      >
                        {loadingTransfer ? "กำลังบันทึก..." : "ยืนยัน"}
                      </Button>
                      <Button
                        disabled={loadingTransfer}
                        className={classNames("rounded", {
                          "bg-red-500": !loadingTransfer,
                          "bg-gray-500 cursor-not-allowed": loadingTransfer,
                        })}
                        onClick={() => setOpenTransfer(false)}
                      >
                        ปิด
                      </Button>
                    </div>
                  </div>
                </Transition.Child>
              </div>
            </Dialog>
          </Transition>

          <Menu
            ref={menuXmlRef}
            as="div"
            className="relative inline-block text-left"
          >
            <div>
              <Menu.Button
                onClick={() => setMenuXml(!menuXml)}
                className="inline-flex w-full justify-center  rounded-full bg-yellow-500 cursor-pointer px-4 py-2 text-sm font-medium text-white hover:bg-opacity-90 focus:outline-none"
              >
                XML (ตอนส่ง)
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="ml-2 -mr-1 h-5 w-5 cursor-pointer"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </Menu.Button>
            </div>
            <Transition
              show={menuXml}
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 mt-2 w-56 z-50 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div className="p-4 flex flex-col space-y-2 ">
                  <Button
                    disabled={loadingXml}
                    onClick={() => onClickXml("EVENT_INTERFACE_CREATE")}
                    className={classNames("rounded-full", {
                      "bg-gray-300 cursor-not-allowed": loadingXml,
                      "bg-yellow-500 cursor-pointer": !loadingXml,
                    })}
                  >
                    XML Interface Create
                  </Button>
                  <Button
                    disabled={loadingXml}
                    onClick={() => onClickXml("EVENT_POST_OTHER_REVENUE")}
                    className={classNames("rounded-full", {
                      "bg-gray-300 cursor-not-allowed": loadingXml,
                      "bg-yellow-500 cursor-pointer": !loadingXml,
                    })}
                  >
                    XML Post Other Revenue
                  </Button>
                  <Button
                    disabled={loadingXml}
                    onClick={() => onClickXml("EVENT_ACCRUED_INTEREST")}
                    className={classNames("rounded-full", {
                      "bg-gray-300 cursor-not-allowed": loadingXml,
                      "bg-yellow-500 cursor-pointer": !loadingXml,
                    })}
                  >
                    XML Accrued Interest
                  </Button>
                  <Button
                    disabled={loadingXml}
                    onClick={() => onClickXml("EVENT_AR_CLEAR")}
                    className={classNames("rounded-full", {
                      "bg-gray-300 cursor-not-allowed": loadingXml,
                      "bg-yellow-500 cursor-pointer": !loadingXml,
                    })}
                  >
                    XML AR Clear
                  </Button>
                  <Button
                    disabled={loadingXml}
                    onClick={() => onClickXml("EVENT_CANCEL")}
                    className={classNames("rounded-full", {
                      "bg-gray-300 cursor-not-allowed": loadingXml,
                      "bg-yellow-500 cursor-pointer": !loadingXml,
                    })}
                  >
                    XML Contract Cancel
                  </Button>
                  <Button
                    disabled={loadingXml}
                    onClick={() => onClickXml("EVENT_SEIZE_VEHICLE")}
                    className={classNames("rounded-full", {
                      "bg-gray-300 cursor-not-allowed": loadingXml,
                      "bg-yellow-500 cursor-pointer": !loadingXml,
                    })}
                  >
                    XML Seize Vehicle
                  </Button>
                  <Button
                    disabled={loadingXml}
                    onClick={() => onClickXml("EVENT_TRANSFER_VEHICLE")}
                    className={classNames("rounded-full", {
                      "bg-gray-300 cursor-not-allowed": loadingXml,
                      "bg-yellow-500 cursor-pointer": !loadingXml,
                    })}
                  >
                    XML Transfer Vehicle
                  </Button>
                </div>
              </Menu.Items>
            </Transition>
          </Menu>

          <Menu
            ref={menuSendRef}
            as="div"
            className="relative inline-block text-left"
          >
            <div>
              <Menu.Button
                onClick={() => setMenuSend(!menuSend)}
                className="inline-flex w-full justify-center  rounded-full bg-pink-500 cursor-pointer px-4 py-2 text-sm font-medium text-white hover:bg-opacity-90 focus:outline-none"
              >
                ส่งข้อมูล
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="ml-2 -mr-1 h-5 w-5 cursor-pointer"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </Menu.Button>
            </div>
            <Transition
              show={menuSend}
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 mt-2 w-56 z-50 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div className="p-4 flex flex-col space-y-2 ">
                  <Button
                    disabled={loadingTrigger}
                    onClick={onClickSendInterfaceCreate}
                    className={classNames("rounded-full", {
                      "bg-gray-300 cursor-not-allowed": loadingTrigger,
                      "bg-pink-500 cursor-pointer": !loadingTrigger,
                    })}
                  >
                    Send Interface Create
                  </Button>
                  <Button
                    disabled={loadingTrigger}
                    onClick={onClickSendPostOtherRevenue}
                    className={classNames("rounded-full", {
                      "bg-gray-300 cursor-not-allowed": loadingTrigger,
                      "bg-pink-500 cursor-pointer": !loadingTrigger,
                    })}
                  >
                    Send Post Other Revenue
                  </Button>
                  <Button
                    disabled={loadingTrigger}
                    onClick={onClickSendAccruedInterest}
                    className={classNames("rounded-full", {
                      "bg-gray-300 cursor-not-allowed": loadingTrigger,
                      "bg-pink-500 cursor-pointer": !loadingTrigger,
                    })}
                  >
                    Send Accrued Interest
                  </Button>
                  <Button
                    disabled={loadingTrigger}
                    onClick={onClickSendARClear}
                    className={classNames("rounded-full", {
                      "bg-gray-300 cursor-not-allowed": loadingTrigger,
                      "bg-pink-500 cursor-pointer": !loadingTrigger,
                    })}
                  >
                    Send AR Clear
                  </Button>
                  <Button
                    disabled={loadingTrigger}
                    onClick={onClickSendCancel}
                    className={classNames("rounded-full", {
                      "bg-gray-300 cursor-not-allowed": loadingTrigger,
                      "bg-pink-500 cursor-pointer": !loadingTrigger,
                    })}
                  >
                    Send Contract Cancel
                  </Button>
                  <Button
                    disabled={loadingTrigger}
                    onClick={onClickSendSeizeVehicle}
                    className={classNames("rounded-full", {
                      "bg-gray-300 cursor-not-allowed": loadingTrigger,
                      "bg-pink-500 cursor-pointer": !loadingTrigger,
                    })}
                  >
                    Send Seize Vehicle
                  </Button>
                  <Button
                    disabled={loadingTrigger}
                    onClick={onClickSendTransferVehicle}
                    className={classNames("rounded-full", {
                      "bg-gray-300 cursor-not-allowed": loadingTrigger,
                      "bg-pink-500 cursor-pointer": !loadingTrigger,
                    })}
                  >
                    Send Transfer Vehicle
                  </Button>
                </div>
              </Menu.Items>
            </Transition>
          </Menu>

          <Menu
            ref={menuTriggerRef}
            as="div"
            className="relative inline-block text-left"
          >
            <div>
              <Menu.Button
                onClick={() => setMenuTrigger(!menuTrigger)}
                className="inline-flex w-full justify-center  rounded-full bg-red-500 cursor-pointer px-4 py-2 text-sm font-medium text-white hover:bg-opacity-90 focus:outline-none"
              >
                ทริกเกอร์ข้อมูล
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="ml-2 -mr-1 h-5 w-5 cursor-pointer"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </Menu.Button>
            </div>
            <Transition
              show={menuTrigger}
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 mt-2 w-56 z-50 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div className="p-4 flex flex-col space-y-2 ">
                  <Button
                    disabled={loadingTrigger}
                    onClick={onClickTriggerDemandFee}
                    className={classNames("rounded-full", {
                      "bg-gray-300 cursor-not-allowed": loadingTrigger,
                      "bg-red-500 cursor-pointer": !loadingTrigger,
                    })}
                  >
                    Trigger (ค่าท่วงถาม)
                  </Button>
                  <Button
                    disabled={loadingTrigger}
                    onClick={onClickTriggerAccrued}
                    className={classNames("rounded-full", {
                      "bg-gray-300 cursor-not-allowed": loadingTrigger,
                      "bg-red-500 cursor-pointer": !loadingTrigger,
                    })}
                  >
                    Trigger Accrued Interest
                  </Button>
                  <Button
                    disabled={loadingTrigger}
                    onClick={onClickTriggerCancel}
                    className={classNames("rounded-full", {
                      "bg-gray-300 cursor-not-allowed": loadingTrigger,
                      "bg-red-500 cursor-pointer": !loadingTrigger,
                    })}
                  >
                    Trigger Cancel (Daily)
                  </Button>
                </div>
              </Menu.Items>
            </Transition>
          </Menu>

          <Menu
            ref={menuInfoRef}
            as="div"
            className="relative inline-block text-left"
          >
            <div>
              <Menu.Button
                onClick={() => setMenuInfo(!menuInfo)}
                className="inline-flex w-full justify-center  rounded-full bg-green-500 cursor-pointer px-4 py-2 text-sm font-medium text-white hover:bg-opacity-90 focus:outline-none"
              >
                ดูข้อมูล
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="ml-2 -mr-1 h-5 w-5 cursor-pointer"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </Menu.Button>
            </div>
            <Transition
              show={menuInfo}
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 mt-2 w-56 z-50 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div className="p-4 flex flex-col space-y-2 ">
                  <Button
                    onClick={() => setOpenModalInterfaceCreate(true)}
                    className="bg-green-500 rounded-full w-full"
                  >
                    Interface Create
                  </Button>
                  <Button
                    onClick={() => setOpenModalPost(true)}
                    className="bg-green-500 rounded-full w-full"
                  >
                    Post Other Revenue
                  </Button>
                  <Button
                    onClick={() => setOpenModalAccruedInterest(true)}
                    className="bg-green-500 rounded-full w-full"
                  >
                    Accrued Interest
                  </Button>
                  <Button
                    onClick={() => setOpenModalARClear(true)}
                    className="bg-green-500 rounded-full w-full"
                  >
                    AR Clear
                  </Button>

                  <Button
                    onClick={() => setOpenModalContractCancel(true)}
                    className="bg-green-500 rounded-full w-full"
                  >
                    Contract Cancel
                  </Button>
                  <Button
                    onClick={() => setOpenModalSeizeVehicle(true)}
                    className="bg-green-500 rounded-full w-full"
                  >
                    Seize Vehicle
                  </Button>
                  <Button
                    onClick={() => setOpenModalTransferVehicle(true)}
                    className="bg-green-500 rounded-full w-full"
                  >
                    Transfer Vehicle
                  </Button>
                </div>
              </Menu.Items>
            </Transition>
          </Menu>

          <Button
            onClick={() => setOpenModal(true)}
            className="bg-blue-500 rounded-full"
          >
            จัดการสินเชื่อ
          </Button>
        </div>
      </div>
      <div className={"grid grid-cols-5 gap-y-1 pt-0 p-3 bg-white "}>
        <Content label="เลขที่สัญญา" value={loan?.loan_id} />
        <Content label="ทะเบียนรถ" value={loan?.plate} />
        <Content
          label="เงินทุน"
          value={numeral(loan?.initCapital).format("0,0.00")}
        />
        <Content
          label="เงินต้นคงเหลือ"
          value={numeral(loan?.capitalRemain).format("0,0.00")}
        />
        <Content
          label="ค่างวดต่อเดือน"
          value={numeral(loan?.payPerMonth).format("0,0.00")}
        />
        <Content label="จำนวนงวด" value={loan?.period} />
        <Content label="ดอกเบี้ย (ต่อปี)" value={loan?.interest + " %"} />
        <Content
          label="ประเภท"
          value={loan?.type === "MOTORBIKE" ? "รถจักรยานยนต์" : "รถยนต์"}
        />
        {/* <Content label="สถานะ" value={loan?.loan_status} /> */}
        <Content
          label="วันเริ่มสัญญา"
          value={moment(loan?.requestTime || loan?.transferDate).format(
            "DD-MM-YYYY"
          )}
        />
        <Content label="Promotion" value={loan?.promo} />
        <Content label="ภาษี" value={loan?.vat} />
        <Content
          label="DueDate"
          value={loan && format(new Date(loan?.overdue_date), "dd-MM-yyyy")}
        />
        {/* <Content
          classNameValue={"text-red-400"}
          label="OverDueDate"
          value={
            loan &&
            differenceInDays(new Date(paidDate), new Date(loan?.overdue_date))
          }
        /> */}
        <Content
          label="วันที่จ่ายล่าสุด"
          value={
            loan?.paidDateLatest !== "-"
              ? moment(loan?.paidDateLatest).format("DD-MM-YYYY")
              : "-"
          }
        />
      </div>
    </div>
  );
};

export default FootageLoanMetaData;
